<template>
  <div class="gallery-list">
    <div v-if="isMobile" class="gallery-list__action">
      <button type="button" class="btn-cloak" @click="onPrev">
        <icon name="backward" width="12" height="21" />
      </button>
      <gallery-step class="gallery-list__step">
        <template v-slot:active>{{ active + 1 }}</template>
        <template v-slot:length>{{ itemListLength }}</template>
      </gallery-step>
      <button type="button" class="btn-cloak" @click="onNext">
        <icon name="forward" width="12" height="21" />
      </button>
    </div>
    <div class="row">
      <div class="col-lg-9">
        <div v-if="selectedItem" class="gallery-list__view" :class="{ 'has-visible': isVisible }">
          <div class="gallery-list__picture">
            <img class="gallery-list__full" :src="selectedItem.full2x" @contextmenu.prevent="onContextmenu">

            <img class="gallery-list__blur" :src="selectedItem.full2x" @contextmenu.prevent="onContextmenu">
          </div>

          <div v-show="selectedItem.caption" class="gallery-list__caption" :style="captionStyle">
            <div class="gallery-list__text" ref="text">{{ selectedItem.caption }}</div>
          </div>

          <div v-if="!isMobile" class="gallery-list__control">
            <button type="button" class="btn-cloak" @click="onPrev">
              <icon class="gallery-list__icon" name="squareBackward" width="59" height="59" />
            </button>
            <button type="button" class="btn-cloak" @click="onNext">
              <icon class="gallery-list__icon" name="squareForward" width="59" height="59" />
            </button>
          </div>
        </div>
      </div>
      <div v-show="!isMobile" class="col-lg-3 col-xl-2 offset-xl-1">
        <div class="gallery-list__action">
          <gallery-step class="gallery-list__step">
            <template v-slot:active>{{ active + 1 }}</template>
            <template v-slot:length>{{ itemListLength }}</template>
          </gallery-step>
          <div class="gallery-list__wheel">
            <div class="gallery-list__thumbs" ref="thumbs" :style="thumbsStyle">
              <a class="gallery-list__thumb" v-for="(item, index) in thumbList" :key="`thumb-${index}`" @click.prevent="onSelect(index)" :class="{'gallery-list__thumb--active': active === index}">
                <img class="gallery-list__image gallery-list__small" width="154" :src="item" @contextmenu.prevent="onContextmenu">
              </a>
              <a class="gallery-list__thumb" v-for="(item, index) in thumbList" :key="`thumb-2-${index}`" @click.prevent="onSelect(index)" :class="{'gallery-list__thumb--active': active === index}">
                <img class="gallery-list__small" width="154" :src="item" @contextmenu.prevent="onContextmenu">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../shared/Icon'
import GalleryStep from './GalleryStep'

export default {
  components: {
    Icon,
    GalleryStep
  },
  props: {
    itemList: Array
  },
  data () {
    return {
      active: 0,
      isVisible: false,
      thumbsH: null,
      captionH: null
    }
  },
  computed: {
    thumbList () {
      return this.itemList.map(item => item.thumb2x)
    },
    selectedItem () {
      return this.itemList[this.active]
    },
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.lg)
    },
    itemListLength () {
      return this.itemList.length
    },
    itemH () {
      if (!this.thumbsH) return 104
      return this.thumbsH / this.itemListLength
    },
    thumbsStyle () {
      if (!this.thumbsH || this.isMobile) return null

      return {
        transform: `translateY(-${this.itemH * this.active}px)`
      }
    },
    captionStyle () {
      if (!this.captionH || this.isMobile) return null

      return {
        height: `${this.captionH + 12}px`
      }
    }
  },
  watch: {
    itemList () {
      this.active = 0
    },
    active () {
      this.isVisible = false

      setTimeout(() => {
        this.isVisible = true
      }, 250)
    },
    isVisible () {
      const { thumbs, text } = this.$refs
      this.thumbsH = (this.getHeight(thumbs) / 2)
      this.captionH = text ? this.getHeight(text) : null
    }
  },
  mounted () {
    setTimeout(() => {
      this.isVisible = true
    }, 250)
  },
  methods: {
    onPrev () {
      this.active -= 1

      if (this.active < 0) {
        this.active = this.itemListLength - 1
      }
    },
    onNext () {
      this.active += 1

      if (this.active >= this.itemListLength) {
        this.active = 0
      }
    },
    onSelect (index) {
      this.active = index
    },
    onContextmenu () {
      return false
    },
    getHeight (el) {
      const rect = el.getBoundingClientRect()

      return rect.height
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery-list {
  @include media-breakpoint-up(lg) {
    height: 485px;
    overflow: hidden;
  }

  @include media-breakpoint-up(xl) {
    height: 467px;
  }

  &__action {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;

    @include media-breakpoint-up(lg) {
      display: block;
      text-align: right;
    }
  }

  &__step {
    margin-left: 30px;
    margin-right: 30px;

    @include media-breakpoint-up(lg) {
      margin: 0 0 20px;
      padding-right: 30px;
      text-align: right;
    }
  }

  &__icon {
    fill: $theme-red-100;
    transition: fill 250ms ease;

    :hover > & {
      fill: $theme-red-200;
    }
  }

  &__view {
    @include media-breakpoint-up(lg) {
      position: relative;
    }
  }

  &__picture {
    height: 340px;
    position: relative;
    overflow: hidden;
    text-align: center;

    @include media-breakpoint-up(lg) {
      height: 485px;
    }

    @include media-breakpoint-up(xl) {
      height: 467px;
    }
  }

  &__full {
    max-height: 100%;
    width: auto;

    @include media-breakpoint-up(lg) {
      height: 100%;
    }
  }

  &__blur {
    display: block;
    filter: blur(8px);
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    z-index: -1;
  }

  &__caption {
    background: $theme-red-200;
    padding-top: 12px;
    text-align: left;

    @include media-breakpoint-up(lg) {
      bottom: 0;
      left: 0;
      position: absolute;
      width: 288px;
      transition: height 100ms ease-in-out;
    }
  }

  &__text {
    background: $theme-red-100;
    bottom: 0;
    color: $white;
    left: 0;
    padding: 20px 30px;
    position: absolute;
    width: 100%;

    @include media-breakpoint-up(lg) {
      transform: translateY(100%);
      transition: transform 250ms ease;

      .has-visible & {
        transform: translateY(0);
      }
    }
  }

  &__control {
    @include media-breakpoint-up(lg) {
      bottom: 0;
      display: flex;
      height: 59px;
      justify-content: space-between;
      position: absolute;
      right: 0;
      width: 120px;
    }
  }

  &__wheel {
    overflow: hidden;
  }

  &__thumbs {
    position: relative;
  }

  &__thumb {
    display: block;
    margin-bottom: 9px;
    position: relative;
    margin-right: 30px;

    &--active {
      &::before {
        background: $theme-red-100;
        bottom: 0;
        content: '';
        display: block;
        position: absolute;
        right: -8px;
        top: 0;
        width: 8px;
      }
    }
  }

  &__small {
    @include img-fluid;
  }
}
</style>
